module.exports = __webpack_public_path__ + "img/logo_.53e310f3.png";